import { render, staticRenderFns } from "./CompleteChip.vue?vue&type=template&id=2759e4f6&"
import script from "./CompleteChip.vue?vue&type=script&lang=ts&"
export * from "./CompleteChip.vue?vue&type=script&lang=ts&"
import style0 from "./CompleteChip.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VChip,VIcon})
